import { ITableFiltersObject } from "@monorepo/utils/src/store/types/tableFiltersObject";
import { convertAutocompleteItemToApi, formDateFilter } from "@monorepo/utils/src/api/convertFiltersToApi";
import { fields } from "@monorepo/utils/src/variables/projectsData/eadStoragePeriodReportView/fields";

export const convertFiltersCustomToApi = (resultFilters: ITableFiltersObject): void => {
  formDateFilter(resultFilters, "eadExpirationDate");
  convertAutocompleteItemToApi(resultFilters, fields.ARCHIVE_NAME, `fieldFilters.${fields.ARCHIVE_NAME}.name`);
  convertAutocompleteItemToApi(resultFilters, fields.FUND_NUMBER, `fieldFilters.${fields.FUND_NUMBER}.number`);
};
